import React from 'react';
import { BookingModal, SelectedServiceDetails } from '../BookingModal';
import { navigateTo } from '../../utils/router';

interface CartPageProps {
  selectedItems: SelectedServiceDetails[];
  onRemoveItem: (id: string) => void;
  onAddItem: (item: SelectedServiceDetails) => void;
  onClearCart: () => void;
}

export const CartPage: React.FC<CartPageProps> = ({
  selectedItems,
  onRemoveItem,
  onAddItem,
  onClearCart
}) => {
  return (
    <div className="cart-page-wrapper">
      <h1 className="sr-only">Your Beauty Cart &amp; Slot Booking | Blishka Doorstep Parlour Bhilai &amp; Durg</h1>
      <BookingModal
        isOpen={true}
        onClose={() => navigateTo('/')}
        selectedItems={selectedItems}
        onRemoveItem={onRemoveItem}
        onAddItem={onAddItem}
        onClearCart={onClearCart}
        isPageView={true}
      />
    </div>
  );
};
